<template>
	<div class="recond">
		<el-table
		  :data="tableData"
		  style="width: 100%">
		  <el-table-column prop="amount" label="Payment"></el-table-column>
		  <el-table-column prop="createDateTime" label="Application Time"></el-table-column>
		  <el-table-column prop="status" label="Status"></el-table-column>
		  <el-table-column prop="details" label="">
			<template slot-scope="scope">
				<el-button @click="detail(scope)" type="text" size="small">Details</el-button>
			</template>
		  </el-table-column>
		</el-table>
		<div >
			<el-dialog
			  title="Record Detail"
			  :append-to-body="true"
			  :visible.sync="dialogVisibletwo"
			  width="60%"
			  :before-close="handleClose"
			  class="iframe-dialog">
			  <div class="mian">
				  <div class="time">
					  <div style="flex: 1;">
						  <div style="margin-bottom: 10px;">Application Time</div>
						  <div>{{details.createDateTime}}</div>
					  </div>
					  
					  <div >Billing Id :{{details.id}}</div>
				  </div>
				  <div class="status">{{details.status}}</div>
				  <div class="amount">
					  <div class="money" >{{details.amount}}</div>
					  <div class="account" v-show="details.paypalEmailAddress && details.bankType == 1">PAYPAL</div>
					  <div class="account" v-show="details.bankBankAccountNo && details.bankType == 2">Bank</div>
				  </div>
				  
				  <div class="bottom" v-show="details.paypalEmailAddress && details.bankType == 1">
				  	  <div style="flex: 1;" > 
				  			<div style="margin-bottom: 10px;">{{details.paypalEmailAddress}}</div>
				  	  </div>
				   </div>
				 <div class="bottom" v-for="item in banklist" >
					  <div style="flex: 1;" v-show="details.paypalEmailAddress && details.bankType == 1">
						  <div style="margin-bottom: 10px;">{{details.paypalEmailAddress}}</div>
					  </div>
					 <div style="flex: 1;" v-show="details.bankBankAccountNo && details.bankType == 2">
						  <div style="margin-bottom: 10px;">{{item.label}}</div>
					  </div>
					   <div v-show="details.bankBankAccountNo && details.bankType == 2">{{item.value}}</div>
				  </div>
				  <div class="amount" v-show="details.reviewDescription && details.status == 'Fail'">
				  	  <div class="reason" >Reason</div>
				  	  <div style="padding-top: 10px;" >{{details.reviewTime}}</div>
				  	  
				  </div>
				  <div class="review" v-show="details.reviewDescription && details.status == 'Fail'">
				  	  <div style="flex: 1;">
				  			<div style="margin-bottom: 10px;">{{details.reviewDescription}}</div>
				  	 </div>
				  	
				   </div>
			  </div>
			  <div class="more">No more</div>
			</el-dialog>
		 </div>
		</div>
  </template>

  <script>
	import { getAuthorCashOutDetailList,GetCashOutReview} from '../common/api/workincome.js'
    export default {
      data() {
        return {
          tableData: [],
		  dialogVisibletwo:false,
		  details:{},
		  tablelist:[],
		  banklist:[
			  {id:1,label:"Receiver's Name",value:""},
			  {id:2,label:"ID/PASSPORT/ Biz Registration No.",value:""},
			  {id:3,label:"Contact number(Include country code)",value:""},
			  {id:4,label:"Bank Account No.",value:""},
			  {id:5,label:"Bank's Full Name",value:""},
			  {id:6,label:"Swift Code ",value:""},
			  {id:7,label:"Branch Code",value:""},
			  {id:8,label:"Location of the branch",value:""},
			  {id:9,label:"Citizenship",value:""},
			  {id:10,label:"Contact Email",value:""},  
		  ]
        }
      },
	  //自定义指令
	  directives: {
		  //自动点击事件
	        clickDown: {
	            inserted(el) {
	                el.click()
	            }
			}
		},
	  created(){
		  this.getList()
	  },
	  methods:{
		handleClick(row) {
		          console.log(row);
		
		}, 
		detail(scope){
			this.dialogVisibletwo = true
			let data = {
			  data:{
			    id:scope.row.id
			  }
			}
			GetCashOutReview(data).then(res=>{
			  if(res.code == 0){
			      this.tablelist = res.data
				  this.details = scope.row
				  if(this.tablelist.length>0){
				  		this.details.reviewDescription = this.tablelist[0].reviewDescription
				  		this.details.reviewTime = this.tablelist[0].reviewTime
						this.details.reviewTime = this.formatDate(this.details.reviewTime)
						//替换指定位置的字符
						const replaceStr = (str, index, char) => {
						 return str.substring(0, index) + char + str.substring(index + 2);
						}
						let aa = this.datescreen(this.details.reviewTime.slice(7,9))
						this.details.reviewTime = replaceStr(this.details.reviewTime.toString(),7,aa)
				  }
				  if(this.details.bankBankAccountNo && this.details.bankType == 2){
				  	this.banklist[0].value = this.details.bankRecevierName
				  	this.banklist[1].value = this.details.passPort
				  	this.banklist[2].value = this.details.bankContactNumber
				  	this.banklist[3].value = this.details.bankBankAccountNo
				  	this.banklist[4].value = this.details.bankBankFullName
				  	this.banklist[5].value = this.details.bankSwiftCode
				  	this.banklist[6].value = this.details.bankCode
				  	this.banklist[7].value = this.details.bankBranchLocation
				  	this.banklist[8].value = this.details.bankCitizenship
				  	this.banklist[9].value = this.details.bankContactEmail
				  } else {
				  	this.banklist = []
				  }
			  }
			  
			  
			})
			// if(this.details.bankBankAccountNo){
			// 	this.banklist[0].value = this.details.bankRecevierName
			// 	this.banklist[1].value = this.details.passPort
			// 	this.banklist[2].value = this.details.bankContactNumber
			// 	this.banklist[3].value = this.details.bankBankAccountNo
			// 	this.banklist[4].value = this.details.bankBankFullName
			// 	this.banklist[5].value = this.details.bankSwiftCode
			// 	this.banklist[6].value = this.details.bankCode
			// 	this.banklist[7].value = this.details.bankBranchLocation
			// 	this.banklist[8].value = this.details.bankCitizenship
			// 	this.banklist[9].value = this.details.bankContactEmail
			// } else {
			// 	this.banklist = []
			// }
				
			
			
		},
		handleClose(done) {
		  this.$confirm('Confirm the shut down？')
		    .then(_ => {
		      done();
		    })
		    .catch(_ => {});
		},
		getList(){
			let data={
				data:{
					authorId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
				}
			}
			getAuthorCashOutDetailList(data).then(res=>{
				console.log('res',res);
				if(res.code == 0){
					this.tableData = res.data
					for(let i in this.tableData){
						this.tableData[i].amount = '$' + this.adjust(this.tableData[i].amount,2)
						this.tableData[i].createDateTime = this.formatDate(this.tableData[i].createDateTime)
						//替换指定位置的字符
						const replaceStr = (str, index, char) => {
						 return str.substring(0, index) + char + str.substring(index + 2);
						}
						let aa = this.datescreen(this.tableData[i].createDateTime.slice(7,9))
						this.tableData[i].createDateTime = replaceStr(this.tableData[i].createDateTime.toString(),7,aa)
						this.tableData[i].status = this.tableData[i].status==10?'Paid':this.tableData[i].status==1?'Processing':this.tableData[i].status==3?'Pending':'Fail'
					}
				}
			})
		},
		//修改时间样式
		formatDate(Time) { //获得UTC的时间
			const moment = require('moment-timezone');
			if (Time == null) {
				return null
			}
			var timezone = "Asia/Shanghai";
			const clean = moment(Time).format('HH:mm MM-DD-YYYY '); // 清除 timezone 信息
			const Shanghailocal = moment.tz(clean, timezone);
			return Shanghailocal.tz('UTC').format(' HH:mm MM-DD-YYYY ')
		},
		datescreen(name){
			switch(name){
				case '01':
					return 'Jan'
					break;
				case '02':
					return 'Feb'
					break;
				case '03':
					return 'Mar'
					break;
				case '04':
					return 'Apr'
					break;
				case '05':
					return 'May'
					break;
				case '06':
					return 'Jun'
					break;
				case '07':
					return 'Jul'
					break;
				case '08':
					return 'Aug'
					break;
				case '09':
					return 'Sep'
					break;
				case '10':
					return 'Oct'
					break;
				case '11':
					return 'Nov'
					break;
				case '12':
					return 'Dec'
					break;
			}
		
		},
		//四舍五入
		adjust(numberRound,roundDigit){
		  if (numberRound>=0){
		  var tempNumber = parseInt((numberRound * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
		  tempNumber += ''
		  if (!/\./.test(tempNumber)) {
		      tempNumber += '.00'
		  }
		  var arrayNum = tempNumber.split('.')
		  if (arrayNum[1].length < 2) {
		     tempNumber += '0'
		  }
		  return tempNumber;
		  } else{
		  var numberRound1=-numberRound;
		  var tempNumber = parseInt((numberRound1 * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
		  return -tempNumber;
		
		  }
		}
	  }
    }
  </script>
  <style lang="scss" scoped="scoped">
	  /deep/.el-dialog{
		  z-index: 999;
	  }
	  .iframe-dialog {
		  .mian{
			  background-color: white;
			  margin-top: 10px;
			  position: relative;
			  box-shadow: 0px 1px 4px rgba(0,0,0,0.3),0px 0px 50px white inset;
			  padding: 20px 20px;
		  }
		  .time{
			  display: flex;
			  margin: 0px 20px 20px 20px;
		  }
		  .status{
			  margin: 0px 20px 20px 20px;
			  font-size: 20px
		  }
		  .amount{
			  display: flex;
			  margin: 0px 20px 10px 20px;
		  }
		  .money{
		  	  flex: 1;
		  	  font-size: 30px;
		  	  color: black;
		  	  font-weight: 700;
		  	  padding-top: 5px;
		  }
		  .account{
			  font-size: 20px;
			  color: #ccc;
			  padding-top: 10px;
		  }
		  .bottom{
			  padding-top: 10px;
			  display: flex;
			  margin: 0px 20px 5px 20px;
		  }
		  .reason{
			  flex: 1;
			  font-size: 20px;
			  color: black;
			  padding-top: 5px;
		  }
		  .review{
			  padding-top: 10px;
			  display: flex;
			  margin: 0px 20px 5px 20px;
		  }
		  .more{
			  text-align: center;
			  margin-top: 20px;
			  font-size: 20px;
		  }
		  
		  
	  }
	  .recond{
	  /deep/.el-table__cell.is-leaf{
	  	background-color: #ccc;
	  }
	  }
  </style>
